export default "__VITE_ASSET__7595c6e3__"